import React from 'react';
import { SliderQuestion, MultipleChoiceQuestion, CommentQuestion, SelectQuestion, SelectQuestionWithOther, MultiSelectQuestion } from './questions';
import { useSurveyContext } from '../contexts/SurveyContext';
import { getPrimaryColor, getSecondaryColor } from '../utils/surveyHelpers';

const COMPONENT_MAP = {
  'one_to_ten': SliderQuestion,
  'excellent_to_poor': MultipleChoiceQuestion,
  'highly_to_unlikely': MultipleChoiceQuestion,
  'yes_no': MultipleChoiceQuestion,
  'one_to_five': MultipleChoiceQuestion,
  'thumbs_up_down': MultipleChoiceQuestion,
  'smiley_frowney': MultipleChoiceQuestion,
  'multi_choice': SelectQuestion,
  'multi_choice_select': MultiSelectQuestion,
  'multi_choice_other': SelectQuestionWithOther,
  'comment': CommentQuestion,
  'nps': SliderQuestion
};

export const QuestionRenderer = () => {
  const { currentQuestion, setAnswer, survey } = useSurveyContext();

  if (!currentQuestion) return null;

  const answer = currentQuestion.answer?.answer;
  const primaryColor = getPrimaryColor(survey);
  const secondaryColor = getSecondaryColor(survey);
  const QuestionComponent = COMPONENT_MAP[currentQuestion.q_type];

  if (QuestionComponent) {
    return React.createElement(QuestionComponent, {
      question: currentQuestion,
      answer: answer,
      onAnswerChange: setAnswer,
      primaryColor: primaryColor,
      secondaryColor: secondaryColor
    });
  }

  return null;
};